<!-- Create entity: no grid row — user picks entity from dropdown -->
<div class="tax-attrib-entity-create-block" style="margin-left: 15px; margin-right: 15px; margin-top: 15px;">
  @if (ctx.loadingEntities) {
<div class="formLoader text-center">
    <i style="color: #e12827; font-size: 36px;" class="fa fa-spinner fa-spin"></i>
  </div>
}

  @if (!ctx.loadingEntities) {
<div class="form-horizontal">
    <div class="row" style="margin-bottom: 12px;">
      <div class="col-md-12">
        <div class="col-md-2 noWrap"><label>Select Entity :</label></div>
        <div class="col-md-2">
          <select gtwSearchableSelect searchPlaceholder="Search entity..."
                  class="form-control" name="entitySelectCreate"
                  [(ngModel)]="ctx.selectedEntity" (ngModelChange)="ctx.setEntityDtls($event)">
            <option value="">-- Select --</option>
            @for (s of ctx.taxAttribEntityData; track $index) {
<option [value]="s.LEID_DTS">{{ s.LEID_DTS }}</option>
}
          </select>
        </div>
        <div class="col-md-2 noWrap"><label>Entity Name :</label></div>
        <div class="col-md-2">
          <input type="text" class="form-control" name="leNameCreate" [(ngModel)]="ctx.leName" readonly>
        </div>
      </div>
    </div>

    <div class="row" style="margin-bottom: 12px;">
      <div class="col-md-12">
        <div class="col-md-2 noWrap"><label>LEID:</label></div>
        <div class="col-md-2">
          <input type="text" class="form-control" name="leidCreate" [(ngModel)]="ctx.leid" readonly>
        </div>
        <div class="col-md-2 noWrap"><label>TAX CODE:</label></div>
        <div class="col-md-2">
          <input type="text" class="form-control" name="cdrNumberCreate" [(ngModel)]="ctx.cdrNo" readonly>
        </div>
        <div class="col-md-2 noWrap"><label>REPORTING PERIOD:</label></div>
        <div class="col-md-2">
          <input type="text" class="form-control" name="reportingPeriodCreate" [(ngModel)]="ctx.rp" readonly>
        </div>
      </div>
    </div>

    <div class="row" style="margin-bottom: 12px;">
      <div class="col-md-12">
        <div class="col-md-2 noWrap"><label>Posting ME:</label></div>
        <div class="col-md-4">
          <ng-container>
            <select class="form-control" name="postingMECreate" [(ngModel)]="ctx.selectedPostingME">
              @if (ctx.selectedPostingMEMissingFromList()) {
<option [value]="ctx.selectedPostingME">{{ ctx.selectedPostingME }}</option>
}
              @for (m of ctx.taxAttribEntityMEList; track $index) {
<option [value]="m.ME_CODE">{{ m.ME_CODE }}</option>
}
            </select>
          </ng-container>
        </div>
      </div>
    </div>

    @if (ctx.taAnnualLimit) {
<div class="row">
      <div class="col-md-12">
        <div style="padding-top: 0 !important;">
          <div id="table_container_entity_create">
            <table class="table table-bordered form-inline customTable custom-table">
              <thead>
                <tr>
                  <th>NOL Type</th>
                  <th>Schedule Start Year</th>
                  <th>Date of Acquisition per GOLD</th>
                  <th>SRLY</th>
                  <th>Override Date of Acquisition</th>
                  <th>Annual Limit</th>
                </tr>
              </thead>
              <tbody>
                @for (row of ctx.taxAttribAnnualLimitData; track $index; let idx = $index) {
<tr class="table1">
                  <td>{{ row.trans_type_desc }}</td>
                  <td>
                    <input type="text" class="form-control" [attr.name]="'schdStartYear_create_' + idx"
                           [(ngModel)]="ctx.schdStartYear"
                           (ngModelChange)="ctx.checkSchdStartYr(row)">
                  </td>
                  <td>
                    <input type="text" class="form-control" [attr.name]="'goldAcqDate_create_' + idx" [(ngModel)]="row.acqDate" readonly>
                  </td>
                  <td style="text-align: center;">
                    <input type="checkbox"
                           [(ngModel)]="row.overrideDateCheck"
                           (change)="ctx.checkAcquisitionDateNew(row)"
                           [disabled]="row.disableSrly">
                  </td>
                  <td>
                    <input type="date" class="form-control"
                           [attr.name]="'overrideDate_create_' + idx"
                           [value]="ctx.overrideDateInputValue(row)"
                           (change)="ctx.onOverrideDateChange(row, $any($event.target).value)"
                           [disabled]="row.disableOverrideDate">
                  </td>
                  <td>
                    <input class="form-control input-md numText"
                           style="text-align: right; width: 85%;"
                           type="text"
                           onlyIntegersWithLength
                           [attr.name]="'annualLimit_create_' + idx"
                           [(ngModel)]="row.amount"
                           (ngModelChange)="ctx.changedAnnualLimit(row)"
                           [disabled]="row.disableAnnualLimit">
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
}

    @if (ctx.entityScheduleMsg) {
<div class="row">
      <div class="col-md-12">
        <span class="color-red">{{ ctx.entityScheduleMsg }}</span>
      </div>
    </div>
}
  </div>
}
</div>
